import { latestArticles, categories } from '@/mocks/articles';
import { Link } from 'react-router-dom';

export default function LatestArticles() {
  return (
    <section className="px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-10 md:mb-14">
          <div>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-300/60 leading-none mb-2">
              最新爆料
            </h2>
            <h3 className="text-3xl md:text-4xl font-heading italic font-semibold text-foreground-950 leading-tight">
              实时追踪 · 永不掉队
            </h3>
          </div>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed lg:max-w-md">
            每日精选全网最新最热的黑料爆料内容，涵盖明星、网红、综艺、音乐等多个圈层，让你成为朋友圈最先知道的那个人。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 mb-12">
          {latestArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group cursor-pointer rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-background-300/80 transition-all duration-300"
            >
              <div className="relative h-52 md:h-56 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-800 text-xs font-medium mb-3">
                  {article.category}
                </span>
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 leading-snug mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 line-clamp-2 mb-4 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-4 text-xs text-foreground-500">
                  <span className="flex items-center gap-1"><i className="ri-time-line"></i>{article.date}</span>
                  <span className="flex items-center gap-1"><i className="ri-eye-line"></i>{article.views} 阅读</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="flex flex-wrap items-center justify-center gap-3">
          {categories.slice(0, 6).map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex items-center gap-2 px-4 py-2 rounded-full bg-background-100 text-foreground-700 text-sm hover:bg-secondary-100 hover:text-secondary-800 transition-colors cursor-pointer"
            >
              <i className={`${cat.icon} text-base`}></i>
              <span>{cat.name}</span>
              <span className="text-xs text-foreground-400">({cat.count})</span>
            </Link>
          ))}
          <Link
            to="/category/society"
            className="flex items-center gap-1.5 px-4 py-2 rounded-full text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors cursor-pointer"
          >
            查看全部分类
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}